import './Dashboard.css';

interface EliminationPanelProps {
  elimination: {
    bladder_pressure: number;
    bowel_pressure: number;
    last_pee_at: string | null;
    last_poop_at: string | null;
  } | null;
}

function getPressureLabel(value: number): { label: string; color: string } {
  if (value > 0.85) return { label: 'Desperate', color: '#ef4444' };
  if (value > 0.65) return { label: 'Urgent', color: '#f97316' };
  if (value > 0.45) return { label: 'Aware', color: '#eab308' };
  if (value > 0.25) return { label: 'Comfortable', color: '#22c55e' };
  return { label: 'Empty', color: '#6b7280' };
}

function getTimeSince(timestamp: string | null): string {
  if (!timestamp) return 'Never';
  const diffMs = Date.now() - new Date(timestamp).getTime();
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  if (hours > 24) return `${Math.floor(hours / 24)}d ago`;
  if (hours > 0) return `${hours}h ${minutes}m ago`;
  return `${minutes}m ago`;
}

export function EliminationPanel({ elimination }: EliminationPanelProps) {
  if (!elimination) return null;

  const bladder = getPressureLabel(elimination.bladder_pressure);
  const bowel = getPressureLabel(elimination.bowel_pressure);

  return (
    <div className="panel elimination-panel">
      <h3 className="panel-title">🚽 Body Functions</h3>
      <div className="elimination-grid">
        {/* Bladder */}
        <div className="elimination-item">
          <div className="elimination-header">
            <span className="elimination-label">💧 Bladder</span>
            <span className="elimination-status" style={{ color: bladder.color }}>
              {bladder.label}
            </span>
          </div>
          <div className="signal-bar-container">
            <div
              className="signal-bar-fill"
              style={{
                width: `${elimination.bladder_pressure * 100}%`,
                backgroundColor: bladder.color,
              }}
            />
          </div>
          <span className="elimination-detail">
            {(elimination.bladder_pressure * 100).toFixed(0)}% • Last: {getTimeSince(elimination.last_pee_at)}
          </span>
        </div>

        {/* Bowel */}
        <div className="elimination-item">
          <div className="elimination-header">
            <span className="elimination-label">💩 Bowel</span>
            <span className="elimination-status" style={{ color: bowel.color }}>
              {bowel.label}
            </span>
          </div>
          <div className="signal-bar-container">
            <div
              className="signal-bar-fill"
              style={{
                width: `${elimination.bowel_pressure * 100}%`,
                backgroundColor: bowel.color,
              }}
            />
          </div>
          <span className="elimination-detail">
            {(elimination.bowel_pressure * 100).toFixed(0)}% • Last: {getTimeSince(elimination.last_poop_at)}
          </span>
        </div>
      </div>
    </div>
  );
}
